import {NavLink} from 'react-router-dom';

export const articulos_informatica_01 =
<div>
<p>
    Todos hemos trabajado con personas o somos personas que suelen nombrar un archivo con una fecha pretendiendo hacer alusión a una versión de éste y al último día en el que se modificó.
    Sólo quiero contarles porque estamos errando. En este artículo les muestro no sólo
    que podemos prescindir de esta costumbre, sino cómo podemos tener mejores prácticas para el versionamiento de archivos. 
    También explico algunos casos en los que podría llegar a ser útil usar la notación de la fecha dentro del nombre del archivo.
</p>
<p className='subTituloSeccion'>
    Descripción de la situación:
</p>
<p>
    Se suele incluir en el nombre del archivo: el día, el mes y el año al que corresponde. Para esto, cada quién según su propio criterio propio utiliza una de varias
    posibles opciones, por ejemplo, para un archivo llamado originalmente "Archivo 1.xlsx", al que se le quiere incluir la fecha 25/01/2022:
</p>
<ul>
    <li> 20200125 Archivo 1.xlsx </li>
    <li> 20200125_Archivo 1.xlsx </li>
    <li> Archivo 1_20200125.xlsx </li>
    <li> Archivo 1 20200125.xlsx </li>
    <li> ... </li>
</ul>
<p>
    Y a su vez, algunas variaciones de la fracción del nombre correspondiente a la fecha:
</p>
<ul>
    <li> 2020-01-25 </li>
    <li> 2020_01_25 </li>
    <li> 25012020 </li>
    <li> 25-01-2020 </li>
    <li> 25_01_2020 </li>
    <li> ... </li>
</ul>
<p className='subTituloSeccion'>
    Diferentes versiones el mismo día:
</p>
<p>
   Primer gran impedimento. Cuando en un mismo día se generen dos versiones diferentes del archivo y se quiera hacer la respectiva diferenciación, se debe
   recurrir a algún sufijo diferenciador, por ejemplo:
</p>
<ul>
    <li> Archivo 1 - 2020_01_25 <b>/</b> Archivo 1 - 2020_01_25 - Final</li>
    <li> Archivo 1 - 2020_01_25 <b>/</b> Archivo 1 - 2020_01_25 - Último</li>
    <li> Archivo 1 - 2020_01_25 <b>/</b> ...</li>
    <li> <b>En el mejor de los casos:</b> Archivo 1 - 2020_01_25 - 01 <b>/</b> Archivo 1 - 2020_01_25 - 02</li>
</ul>
<p className='subTituloSeccion'>
    Confusión entre fechas:
</p>
<p>
    Un archivo informático puede tener relación con diversas fechas, no sólo con la fecha asociada al versionamiento. Supongamos que una dependencia de cierta entidad
    debe emitir un informe diario, en este caso sería de bastante utilidad (incluso obligatorio) relacionar la fecha del reporte en el nombre del archivo, dejándonos sin la posiblidad
    de usar la notación de fecha para referirnos a diferentes versiones del mismo reporte. Otro caso puede ser el archivo de una presentación que se va a realizar en
    una fecha determinada, nombrar el archivo con la fecha de versionamiento puede prestarse para malentendidos.
</p>
<p>
    En otro contexto, cuando se usa el nombramiento con fecha, creo que lo último que queremos es estar renombrando el archivo cada día en un proceso de 
    retroalimentación continua; supongamos que tu jefe te pide que le envies un documento para revision, usas la notación de la fecha del día en que lo elaboras y se
    lo envias, él te devuelve el archivo con algunas observaciones que te van a tomar más de 1 día en atenderlas. La pregunta es, para que la versión inicial que enviaste te quede
    diferenciada, ¿cómo deberias nombrar la siguiente versión en la que vas a empezar a trabajar?
</p>
<ul>
    <li> 
        <b>La puedes nombrar con el día en el que vas a empezar a atender las obsevaciones: </b> 
        Esto no te dejaría más que: enviar el archivo el día en que termines con una fecha anterior o renombrar el archivo cada día hasta el día en que lo envíes.
    </li>
    <li> 
        <b>Nombrarlo con una anotación temporal y renombrarlo con la fecha del día en que lo termines y lo envíes</b> 
    </li>
</ul>
<p>
    Si te das cuenta, todo esto es confuso y también innesesario, como lo podrás ver más adelante.
</p>
<p className='subTituloSeccion'>
    Delegación de tareas:
</p>
<p>
    Cada componente y/o funcionalidad que encontramos en las diferentes soluciones informáticas, tiene su razón de ser y si la usamos correctamente, podemos
    obtener ventajas significativas. La fecha en la que un documento es editado o enviado es almacenada por las herramientas que usamos y no es recomendable
    que intentemos hacer manual una tarea que ya es automática. Debemos aprender a diferenciar entre la última fecha de edición y el versionamiento.
</p>
<p>
    Trabajando en el sistema operativo de nuestro dispositivo, tendremos acceso a la última fecha de edición de un archivo y así podremos tener diferentes
    versiones de un mismo archivo (usando la notación recomendada de la que hablaremos más adelante) con las respectivas fechas de edición. Esto también aplica
    para los archivos almacenados en la nube, con la ventaja de que allí además de la fecha obtenemos la identidad de la persona que realizó la edición; casi
    que en estos casos podríamos prescindir del versionamiento, pero en algunas ocasiones vamos a querer tener diferentes versiones que nos muestren la evolución
    del archivo y que en determinado caso podamos volver a alguna de ellas sin mayores esfuerzos.
</p>
<p>
    Si usamos la fecha en el nombramiento de archivos, estamos automáticamente renunciando a las opciones que nos da la fecha almacenada en las diferentes plataformas,
    estaríamos haciendo una mescolanza de todo con todo. Ahora, la fecha de nuestros dispositivos locales presenta una situación, ésta es cambiada una vez el archivo
    es puesto en algún contexto de internet, esto quiere decir, por ejemplo, que si yo edité un archivo el 25/01/2022 y lo envié por correo el 27/01/2022, cuando lo
    descargue, la última fecha de edición será del 27/01/2022 y sabemos que esa no fue la última fecha real de edición; esta situación la podemos manejar 
    siguiendo las recomendaciones que les daré más adelante.
</p>
<p className='subTituloSeccion'>
    Visualmente:
</p>
<p>
    El peor escenario, incluir la fecha al inicio del archivo, ya sea en la nube o en nuestro dispositivo local, la opción de ordenar por nombre se nos vuelve
    un completo desorden, si bien podemos acceder a las últimas/primeras versiones de todos los archivos de una carpeta, no tenemos la opción de ver las versiones
    de un mismo archivo claramente:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440060/imagen01_v4oivp.png' alt='imagen01' style={{maxWidth:"100%"}}></img>
</p>
<p>
    Y mi opinión, no sé la de ustedes, es que en el ejemplo anterior lo único que vemos es un gran desorden y eso que tenemos una mínima cantidad de archivos,
    imaginémonos algo así con muchos archivos, con nombres más largos y muchas más versiones, ¡un caos!.
</p>
<p>
    Veremos la fecha por doquier en nuestro sistema operativo, en algunos casos solamente se reducirá a la incomodidad visual
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440217/imagen02_up918p.png' alt='imagen02' style={{maxWidth:"100%"}}></img>
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440217/imagen03_oe2lfx.png' alt='imagen03' style={{maxWidth:"100%"}}></img>
</p>
<p>
    En otros casos, será mucho más que una simple molestia, en el siguiente ejemplo muestro 2 archivos de excel abiertos en pestañas desagrupadas de Windows, la fecha
    en el mejor de los casos ocupa la mitad del nombre visible del archivo, si tenemos nombres similares no sabremos cuál archivo es cuál con una simple mirada:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440217/imagen04_hj1bgq.png' alt='imagen04' style={{maxWidth:"100%"}}></img>
</p>
<p>
    Ahora en pestañas agrupadas:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440218/imagen05_vyjqpb.png' alt='imagen05' style={{maxWidth:"100%"}}></img>
</p>
<p>
    No mejora mucho. ¿Cierto?
</p>
<p className='subTituloSeccion'>
    Una solución práctica:
</p>
<p>
    Bien, ya vimos algunos de los inconvenientes que puede traer esta costumbre. ¿Que hacemos entonces?. El apropiado nombramiento de archivos está relacionado
    directamente con la productividad en nuestro trabajo, dar nombres explicativos y concisos nos puede tomar unos segundos, pero a la hora de encontrar nuestros
    archivos nos puede ahorrar varios minutos; más aún si debemos nombrar diferentes versiones.
</p>
<p>
    Un concepto fundamental para el versionamiento de archivos: cada archivo debe tener un solo responsable en términos de contenido y versionamiento, esto no quiere
    decir que un documento no pueda ser elaborado por varias personas. Tener un responsable no sólo trae ventajas en la organización del archivo si no en la
    operatividad de nuestro trabajo, cualquier tema relacionado con el desarrollo de la construcción de un archivo podrá ser consultado de forma centralizada
    a través del responsable de éste, asimismo, éste podrá dar razón acerca de las versiones existentes.
</p>
<p>
    El nombramiento relativo a la versión que les recomiendo es haciendo uso de un consecutivo como sufijo del nombre original, a éste podremos agregarle un código
    que nos indique que es relativo a la versión, para mí, con una 'V' es suficiente. Veamos uno de los ejemplos anteriores con esta notación:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440217/imagen06_lgwzjq.png' alt='imagen06' style={{maxWidth:"100%"}}></img>
</p>
<p>
    Mejora, ¿verdad?. También podemos observar que utilizamos un guión con espacio para separar la versión del archivo, esto nos da una mejor impresión visual, también
    hacemos uso de un consecutivo de doble dígito, esto nos permitirá tener hasta 99 versiones de un mismo archivo (o 100 si decidimos iniciar con la V00).
</p>
<p>
    ¿Cuándo cambiamos de versión?, una versión debe hacer referencia a un hito en el estado de construcción de un archivo, los hitos de versionamiento los definimos
    nosotros de acuerdo a la situación. El versionamiento también se ve afectado directamente con los envíos del archivo a otra persona con el objetivo de recibir comentarios
    o complementar la información consignada.
</p>
<p>
    Es importante que el prefijo del archivo (el nombre como tal) sea exactamente igual en todas las versiones, esto nos permitirá usar de forma apropiada
    las opciones de ordenamiento que nos ofrecen todas las plataformas tecnológicas de hoy en día.
</p>
<p>
    Veamos entonces las pautas específicas a tener en cuenta para versionar un archivo de forma exitosa:
</p>
<p className='subTituloSeccion'>
    Edición lineal:
</p>
<p>
    Si bien la nube se ha convertido en una opción para el trabajo compartido y simultáneo en archivos informáticos, para algunas situaciones puede ser más efectivo
    el trabajo de forma lineal en el que se realiza la edición del archivo por parte de una sola persona a la vez y que sigue un flujo de cambio de personas en la edición
    pero bajo un responsable solamente (con opción de cambio). Este escenario aplica por ejemplo, a casos de archivos que deben ser trabajados en su mayoría por una única persona pero que
    están sujetos a revisiones por parte de otros actores, también existen escenarios en los que cada actor debe intervenir en el archivo una vez otro actor ha
    finalizado su trabajo. Trabajar en la nube un archivo que presente claramente estas condiciones o similares, puede traer inconvenientes, ya que tendríamos
    que estar enviando comunicaciones formales o informales a los diferentes actores involucrados indicándoles que ya pueden entrar a revisar y cambiar el archivo que
    está compartido y almacenado en la nube, esto claramente hace que se pierda el seguimiento del archivo y se preste para confusiones.
</p>
<p>
    En este escenario es posible cambiar el responsable del archivo, por ejemplo, si estás proyectando un documento para tu jefe, una vez lo envías,
    él decide hacer unos pequeños ajustes sin necesidad de devolvértelo y procede a enviarlo al destinatario final, antes de enviarlo él debe ser el nuevo 
    responsable del archivo y por consiguiente debería versionarlo.
</p>
<p>
    Sea quien sea el responsable actual, la regla es: una vez el archivo es enviado a otro actor y requiera alguna modificación posterior, se debe
    generar una nueva versión.
</p>
<p>
    Si eres el responsable del archivo y estás en tu dispositivo construyéndolo, versiona solamente cada vez que avances en términos sustanciales
    y acotables (por ejemplo, si avanzas en una sección o sub-sección de un documento).
</p>
<p>
    Cuando envías un archivo para observación y sigues siendo el responsable, para evitar que un archivo sea confundido en los envíos por internet,
    la persona que hace observaciones (y no es la responsable) sobre un archivo versionado, debe incluir un sufijo en el nombre del archivo (ej: V03 - Obs Carlos),
    el archivo incluso puede seguir un flujo de varios actores que hagan obsevaciones y anotaciones, lo importante es que una vez el archivo vuelva al
    responsable se genere la nueva versión.
</p>
<p>
    Veamos un ejemplo de resumen del versionamiento con edición lineal:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440218/imagen07_ecvqbm.png' alt='imagen07' style={{maxWidth:"100%"}}></img>
</p>
<p>
    Observamos que Carlos inicia siendo el responsable del archivo, trabaja 3 versiones en su dispositivo, enseguida Juan hace cambios en el archivo
    (lo recibe vía email como <b>Reporte - V03.xlsx</b> y lo renombra inmediatamente en su dispositivo haciendo los cambios pertinentes),
    luego Paula hace la misma operación (lo recibe como <b>Reporte - V03 - Obs Juan.xlsx</b> y lo renombra como <b>Reporte - V03 - Obs Juan - Paula.xlsx</b>), 
    el nombre del archivo se puede ir distorsionando, lo importante es que al volver a Carlos, él como responsable lo recibe y lo renombra como <b>Reporte - V04.xlsx</b>;
    trabaja un par de versiones más en su dispositivo y lo envía a María, ella lo guarda con sufijo <b>- Obs María</b>, hace unas cambios y se da cuenta
    que no es necesario que Carlos vuelva a modificar el archivo, así que en ese momento hay un cambio de responsable, ella renombra el archivo y lo envía al
    destinatario final (Pedro), éste decide hacer unas observaciones y devolverlo a María para corrección, ella lo recibe y considera que los cambios los debe
    realizar Carlos, así que lo puede enviar directamente con el nombre que le asignó Pedro, Carlos en ese momento puede volverse el responsable del
    archivo nuevamente y renombrarlo como <b>Reporte - V08.xlsx</b>, trabaja en los cambios y genera la <b>V09</b> del archivo la cual envía a María que procede
    a revisar, al no tener observaciones, lo envía directamente al destinatario final que aprueba la versión.
</p>
<p className='subTituloSeccion'>
    Edición simultánea:
</p>
<p>
    El versionamiento en archivos compartidos en la nube y de edición simultánea solamente es recomendado en los casos que queremos dejar un avance explícito
    en un archivo separado, la clave para que este escenario resulte exitoso es que los editores del archivo hagan cambios solamente sobre la última versión.
    El responsable del archivo en este caso es el que crea las nuevas versiones. Existen servicios de nube que permiten tener versiones sobre un mismo archivo,
    en este caso siempre es mejor usar el servicio de versionamiento:
</p>
<p>
    <img src='https://res.cloudinary.com/dimzuthhj/image/upload/v1768440218/imagen08_tlike5.png' alt='imagen08' style={{maxWidth:"100%"}}></img>
</p>
<p>
    En este ejemplo de Google Drive, tenemos un archivo llamado <b>Reporte.xlsx</b>, para crear una nueva versión, descargamos la versión actual y enseguida
    la subimos como nueva versión, de esta manera quedará un archivo versionado a la fecha disponible y las ediciones se harán solamente sobre la versión actual.
</p>
<p className='subTituloSeccion'>
    ¿Cuando usar la fecha dentro del nombre del archivo?:
</p>
<p>
    Te había comentado acerca de algunas excepciones en las que recomiendo incluir una fecha en el nombre del archivo, estas situaciones pueden ser combinadas
    con el versionamiento que planteo en este artículo sin ninguna incompatibilidad.
</p>
<ul>
    <li> 
        <b>Una copia de un repositorio de datos: </b> 
        Supongamos que tenemos una base de datos o un repositorio centralizado que tiene una metodología definida para su actualización y estos datos tienen
        un alto grado de variabilidad temporal. Cuando hacemos una consulta de esa base, es importante saber la fecha de esa consulta, así las personas que vayan
        a tener acceso a ese archivo generado tengan clara la fecha de corte de los datos que están visualizando.
    </li>
    <li> 
        <b>Cuando el contenido se refiere implícitamente a una fecha: </b>En un ejemplo mencionado previamente, hacíamos referencia a un reporte diario, lo que estamos
        incluyendo en ese archivo hace referencia a los acontecimientos, operaciones, etc., asociados directamente a una fecha.
    </li>
</ul>
<p>
    En estos casos, o similares. Es fundamental que la fecha se incluya como sufijo del nombre, por ejemplo: <b>Reporte diario 25_01_2022.xlsx</b> y si el archivo requiere versiones:
</p>
<ul>
    <li> 
        <b>Reporte diario - 2022_01_25 - V01.xlsx</b> 
    </li>
    <li> 
        <b>Reporte diario - 2022_01_25 - V02.xlsx</b> 
    </li>
</ul>
<p>
    Para el caso de reportes de una base de datos, casi en ningún caso se debería usar versionamiento y casi en todos los casos deberíamos incluir la hora, en 
    el siguiente ejemplo se muestra un ejemplo de nombramiento para dos reportes iguales de una base de datos del 25/01/2022 (a las 10:30 am y 3:00 pm respectivamente)
</p>
<ul>
    <li> 
        <b>Reporte BD - 2022_01_25_10_30.xlsx</b> 
    </li>
    <li> 
        <b>Reporte BD - 2022_01_25_15_00.xlsx</b> 
    </li>
</ul>
<p>
    Es posible que se requiera incluir solamente el año y el mes como parte de la fecha al nombrar un archivo, para el caso de un informe mensual por ejemplo
     o para una factura de un servicio público, entre otros.
</p>
<p>
    Los signos de separación, los puedes escoger a tu gusto; para separar el nombre del archivo, la versión y la fecha me gusta usar un guión medio con espacio
    antes y después, para separar las partes de la fecha y hora me gusta la raya al piso, para archivos que no son tan técnicos, tal vez queremos usar un nombre 
    más limpio, en ese caso te puedo recomendar algo así: <b>Reporte BD - 2022 01 25.xlsx</b>. Lo que es necesario es que el versionamiento tenga la misma estructura
    con los mismos dígitos siempre y la fecha/hora se escriba de lo general a lo específico (primero el año y así sucesivamente). Si optas por utilizar los nombres de los meses, esto
    te puede dar un mejor entendimiento del archivo, pero no podrás aprovechar las herramientas de ordenamiento de los diferentes sistemas, para esto, te 
    recomiendo que uses una notación de este tipo: <b>Recibo - 2020 02 Febrero</b>.
</p>
<p>
    Espero que este artículo te sea útil y lo aproveches. No dudes en comentar o en contactarme si quieres resolver alguna duda o complementar el contenido.
</p>
<p>
    También te invito a que conozcas mi artículo acerca de la <NavLink to="/articulos_informatica_02"> organización de archivos informáticos</NavLink>
</p>
</div>